<footer>
    <ac-footer-links />
    <ac-legal-links />
</footer>